
export default {

    beforeLogincallUrl:function(url,data,success,error){//登录前数据异步请求
        let beforeLoginAuthorization="Basic" + " " + this.encode("cloudrising_front" + ':' + "cloudrising123456789");//登录前header
        sessionStorage.setItem("beforeLoginAuthorization",beforeLoginAuthorization)//存储到session里面
        return this.beforeLoginApiAxios(url , data , success,error)
    },
    beforeLoginApiAxios:function(url,data,success,error){//登录前异步请求
        // 通过fetch异步请求后台
        fetch(url, {
            method: 'POST',
            body: new URLSearchParams(this.deploy(false,url,data)).toString() ,// 这里是请求对象
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', // 指定提交方式为表单提交
                'Authorization':sessionStorage.getItem('beforeLoginAuthorization')//登录前的header
            }),
        })
        .then((res)=>{
            if(url.indexOf("gn-fileserver")>-1){//如果是文件转换为blob格式，其余转化为json格式
                return res.blob();
            }else{
                return res.json();
            }
            // return res.text()
        })
        .then((res)=>{
            let data =res;
            let data1="";
            if(url.indexOf("gn-fileserver")>-1){//如果是文件直接返回，否则返回主体部分
                data1=data;
            }else{
                data1=data.dataPackage.business;
            }
            return success(data1);//这里
        })
        .catch((res)=>{
           return error('系统异常')
        })
    },
    callUrl:function(url,data,success,error){//登录后不封装入参数据异步请求
        return this.apiAxios(url , data , success,error)
        
    },
    apiAxios:function(url,data,success,error){//登录后不封装入参数据异步请求
        // 通过fetch异步请求后台
        fetch(url, {
            method: 'POST',
            body: new URLSearchParams(this.deploy(false,url,data)).toString() ,// 这里是请求对象
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', // 指定提交方式为表单提交
                'Authorization':sessionStorage.getItem('afterLoginAuthorization')
            }),
        })
        .then((res)=>{
            if(url.indexOf("gn-fileserver")>-1){//如果是文件转换为blob格式，其余转化为json格式
                return res.blob();
            }else{
                return res.json();
            }
            // return res.text()
        })
        .then((res)=>{
            let data =res;
            let data1="";
            if(url.indexOf("gn-fileserver")>-1){//如果是文件直接返回，否则返回主体部分
                data1=data;
            }else{
                data1=data.dataPackage.business;
            }
            return success(data1);//这里
        })
        .catch((res)=>{
            return error('系统异常')
         })
    },
    noLoginCallUrl:function(url,data,success,error){//不用登陆请求数据(封装数据)
        let beforeLoginAuthorization="Basic" + " " + this.encode("cloudrising_front" + ':' + "cloudrising123456789");//登录前header
        sessionStorage.setItem("beforeLoginAuthorization",beforeLoginAuthorization)//存储到session里面
        return this.noLoginApiAxios(url , data , success,error)

    },
    noLoginCallUrl4GET:function(url,success,error){//不用登陆请求数据(封装数据)
        console.log(1)
        let beforeLoginAuthorization="Basic" + " " + this.encode("cloudrising_front" + ':' + "cloudrising123456789");//登录前header
        sessionStorage.setItem("beforeLoginAuthorization",beforeLoginAuthorization)//存储到session里面
        return this.noLoginApiAxios4GET(url , success,error)

    },
    noLoginApiAxios:function(url,data,success,error){//登录前封装入参数据异步请求
        // 通过fetch异步请求后台
        fetch(url, {
            method: 'POST',
            body: new URLSearchParams(this.deploy(true,url,data)).toString() ,// 这里是请求对象
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', // 指定提交方式为表单提交
                'Authorization':sessionStorage.getItem('beforeLoginAuthorization')
            }),
        })
        .then((res)=>{
            if(url.indexOf("gn-fileserver")>-1){//如果是文件转换为blob格式，其余转化为json格式
                return res.blob();
            }else{
                return res.json();
            }
            // return res.text()
        })
        .then((res)=>{
            let data =res;
            let data1="";
            if(url.indexOf("gn-fileserver")>-1){//如果是文件直接返回，否则返回主体部分
                data1=data;
            }else{
                data1=data.dataPackage.business;
            }
            return success(data1);//这里
        })
        .catch((res)=>{
            return error('系统异常')
         })
    },
    afterLoginCallUrl:function(url,data,success,error){//登录后数据异步请求
        let self =this;
        var date=(new Date()).getTime();
        var token=sessionStorage.getItem("afterLoginAuthorization")
        var refresh_token=sessionStorage.getItem("refresh_token");
        var expires_in=sessionStorage.getItem("expires_in")
        if(token && date>=expires_in){
            if (!JSON.parse(localStorage.getItem('tokenflage'))) {
                this.beforeLoginApiAxios("/api/base-oauth-core/authentication/refreshtoken",{"refresh_token":refresh_token},function(res){
                    if(res.code=="000000"){
                        self.settoken(res)
                        localStorage.setItem('tokenflage', false)
                        return self.afterLoginApiAxios(url , data , success,error)
                    }else{
                        localStorage.setItem('tokenflage', false)
                        alert(res.msg);
                    }
                },function(res){
                    return error(res.msg)
                })
            }else{
                setTimeout(function() {
                    self.afterLoginCallUrl(url, data, sccess, error)
                }, 300)
            }
            

        }else{
            return this.afterLoginApiAxios(url , data , success,error)
        }
        
    },
    afterLoginApiAxios:function(url,data,success,error){//登录后异步请求
        // 通过fetch异步请求后台
        fetch(url, {
            method: 'POST',
            body: new URLSearchParams(this.deploy(true,url,data)).toString() ,// 这里是请求对象
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', // 指定提交方式为表单提交
                'Authorization':sessionStorage.getItem('afterLoginAuthorization')
            }),
        })
        .then((res)=>{
            if(url.indexOf("gn-fileserver")>-1){//如果是文件转换为blob格式，其余转化为json格式
                return res.blob();
            }else{
                return res.json();
            }
            // return res.text()
        })
        .then((res)=>{
            let data =res;
            let data1="";
            if(url.indexOf("gn-fileserver")>-1){//如果是文件直接返回，否则返回主体部分
                data1=data;
            }else{
                data1=data.dataPackage.business;
            }
            return success(data1);//这里
        })
        .catch((res)=>{
            return error('系统异常')
         })
    },
    noLoginApiAxios4GET:function(url,success,error){//不登录封装入参数据get请求
        console.log(2)
        // 通过fetch异步请求后台
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json', // 指定提交方式为表单提交
                'Authorization':sessionStorage.getItem('beforeLoginAuthorization')
            }),
        })
        .then((res)=>{
            if(url.indexOf("gn-fileserver")>-1){//如果是文件转换为blob格式，其余转化为json格式
                return res.blob();
            }else{
                return res.json();
            }
            // return res.text()
        })
        .then((res)=>{
            let data =res;
            let data1="";
            if(url.indexOf("gn-fileserver")>-1){//如果是文件直接返回，否则返回主体部分
                data1=data;
            }else{
                data1=data.dataPackage.business;
            }
            return success(data1);//这里
        })
        .catch((res)=>{
            return error('系统异常')
         })
    },
    deploy:function(bool,url,params){//入参封装
        var data="";
        if(!bool){//true需要封装，false不需要封装
            data=params
        }else{
            data={
                "dataKey":JSON.stringify({
                    "pcode":"",
                    "pmsg":"",
                    "dataPackage":{
                        "cryptFlag":0,
                        "hashFlag":0,
                        "hash":"",
                        "signatureFlag":0,
                        "signature":"",
                        "business":{
                            "data":params
                        }
                    }
                })
            }
        }
        return data;
    },
    encode:function(data){//加密
        var base = new Base64();  
        var result = base.encode(data);  
        return result;
    },
    decode:function(data){//解密
        var base = new Base64();  
        var result = base.decode(data);  
        return result;
    },
    settoken:function(res){//token存储
        var tokenType=res.data.token_type
        var token=res.data.access_token
        var Authorization=tokenType+' '+token
        var expires_in=(new Date()).getTime()+Number((res.data.expires_in-20)*1000)
        var refresh_token=res.data.refresh_token
        sessionStorage.setItem("afterLoginAuthorization",Authorization)//tokenid
        sessionStorage.setItem("loginoutAuthorization",Authorization)//用于退出登录接口调用
        sessionStorage.setItem("expires_in",expires_in)//过期的时间戳
        sessionStorage.setItem("refresh_token",refresh_token)//刷新token的参数
    },
}
function Base64() {//加解密 
    // 私钥
    var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    // 加密
    this.encode = function (input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        input = this._utf8_encode(input);
        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output = output +
                _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
                _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
        }
        return output;
    }
    // 解密
    this.decode = function (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
            enc1 = _keyStr.indexOf(input.charAt(i++));
            enc2 = _keyStr.indexOf(input.charAt(i++));
            enc3 = _keyStr.indexOf(input.charAt(i++));
            enc4 = _keyStr.indexOf(input.charAt(i++));
            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }
        }
        output = this._utf8_decode(output);
        return output;
    }
    // private method for UTF-8 encoding
    this._utf8_encode = function (string) {
        string = string.replace(/\r\n/g,"\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }
        }
        return utftext;
    }
    // private method for UTF-8 decoding
    this._utf8_decode = function (utftext) {
        var string = "";
        var i = 0;
        var c = c1 = c2 = 0;
        while ( i < utftext.length ) {
            c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i+1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i+1);
                c3 = utftext.charCodeAt(i+2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }
        return string;
    }
}